import React from 'react';
import { XCircle } from 'lucide-react';
export function SalesLetterSection() {
  return <section className="py-4 bg-[#050505]" data-id="element-121">
      <div className="max-w-[800px] mx-auto px-4" data-id="element-122">
        <div className="text-center mb-4" data-id="element-123">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-white uppercase inline-block border-b-4 border-orange-500 pb-1" data-id="element-124">
            ESTE LIBRO ES PARA VOS SI...
          </h2>
        </div>
        <div className="mb-4 rounded-xl overflow-hidden border border-orange-500/30" data-id="element-125">
          <video src="https://cdn.magicpatterns.com/uploads/ue2qZNWHq5tXTFyG6MStS8/Video para Facebook noticia de último momento moderno rojo y gris.mp4" autoPlay muted loop playsInline className="w-full h-auto object-cover" data-id="element-126" />
        </div>
        <div className="space-y-2 mb-4" data-id="element-127">
          <div className="flex items-start bg-red-950/50 p-3 rounded-lg border border-red-500/20" data-id="element-128">
            <XCircle className="w-5 h-5 text-red-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-129" />
            <p className="text-sm text-slate-300 font-medium" data-id="element-130">
              <span className="font-bold text-white" data-id="element-131">Estás estancado</span>{' '}
              ganando siempre lo mismo porque te falta confianza para aceptar
              trabajos más grandes.
            </p>
          </div>
          <div className="flex items-start bg-red-950/50 p-3 rounded-lg border border-red-500/20" data-id="element-132">
            <XCircle className="w-5 h-5 text-red-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-133" />
            <p className="text-sm text-slate-300 font-medium" data-id="element-134">
              <span className="font-bold text-white" data-id="element-135">
                Sentís que podrías fabricar cosas increíbles
              </span>
              , pero no sabés por dónde empezar.
            </p>
          </div>
          <div className="flex items-start bg-red-950/50 p-3 rounded-lg border border-red-500/20" data-id="element-136">
            <XCircle className="w-5 h-5 text-red-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-137" />
            <p className="text-sm text-slate-300 font-medium" data-id="element-138">
              <span className="font-bold text-white" data-id="element-139">Te frustrás</span> porque
              no tenés un paso a paso claro y terminás perdiendo tiempo,
              materiales y rentabilidad.
            </p>
          </div>
          <div className="flex items-start bg-red-950/50 p-3 rounded-lg border border-red-500/20" data-id="element-140">
            <XCircle className="w-5 h-5 text-red-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-141" />
            <p className="text-sm text-slate-300 font-medium" data-id="element-142">
              <span className="font-bold text-white" data-id="element-143">
                No sabés qué proyectos fabricar
              </span>{' '}
              de herrería que realmente se vendan y te generen ingresos.
            </p>
          </div>
        </div>
        <div className="mb-4" data-id="element-144">
          <h3 className="text-xl md:text-2xl font-heading font-bold text-center mt-2 text-white uppercase" data-id="element-145">
            APRENDÉ LAS TÉCNICAS DE HERRERÍA PROFESIONAL Y FABRICA MILES DE
            PROYECTOS RENTABLES
          </h3>
          <div className="mt-3" data-id="element-146">
            <img src="https://cdn.magicpatterns.com/uploads/iiSxQgh2NcomRRnwDftqpN/Diseno_sin_titulo_(1).png" alt="Proyectos de herrería profesional - muebles industriales de hierro y madera" className="w-full max-w-2xl mx-auto rounded-xl shadow-orange-500/20" data-id="element-147" />
          </div>
        </div>
      </div>
    </section>;
}